import { render, staticRenderFns } from "./NewsChart.vue?vue&type=template&id=77394e5a&scoped=true"
import script from "./NewsChart.vue?vue&type=script&lang=js"
export * from "./NewsChart.vue?vue&type=script&lang=js"
import style0 from "./NewsChart.vue?vue&type=style&index=0&id=77394e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77394e5a",
  null
  
)

export default component.exports